export default __webpack_public_path__ + "i18n/hu.8347cb21f8f6dd5c94bf9000deabc4dc.json";